import { ActionType, IProfile } from './model'
import { Action, Nullable } from '../model'
import createReducer from '../createReducer'

export interface IProfileReducer {
  profile: Nullable<IProfile>
}

const defaultState: IProfileReducer = {
  profile: null,
}

export const profileReducer = createReducer<IProfileReducer>(defaultState, {
  [ActionType.SET_PROFILE](state: IProfileReducer, action: Action<any>) {
    return { ...state, profile: action.payload }
  },
})
